export default __webpack_public_path__ + "static/media/document.2358d00d.pdf";